import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useState, useEffect } from "react";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import moment from "moment";
import request, { gql } from "graphql-request";
import {
  Box,
  Card,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material";

const localizer = momentLocalizer(moment);

const attendance = gql`
  query userAttendance($id: String!) {
    userAttendanceDetails(id: $id) {
      id
      checkIn
      checkOut
      totalWorkingHours
      overtime
      lastUpdate
    }
  }
`;
const leaveDetails = gql`
  query leaveTrackDetails($empoloyeeid: String!) {
    leaveRequestsByMe(id: $empoloyeeid) {
      id
      user {
        id
        empid
        username
      }
      requestedOn
      leaveType {
        leaveType
      }
      leaveFrom
      leaveTill
      reason
      totalDays
      teamApproval
      hrApproval
      status
    }
  }
`;

const Callender = () => {
  const [events, setEvents] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const user = sessionStorage.getItem("user");
  const userId = JSON.parse(user).id;
  const encodedId = btoa(userId);
  const theme = useTheme();

  useEffect(() => {
    const fetchUserAttendance = async () => {
      try {
        const attendanceRes = await request(BASEURL, attendance, {
          id: "VXNlck5vZGU6" + "" + encodedId,
        });

        setEvents(attendanceRes.userAttendanceDetails);
        setLoading(false);
      } catch (err) {
        setError("Error fetching attendance data.");
        setLoading(false);
        console.error("Error fetching check-in data:", err);
      }
    };
    const fetchUserAttendance3 = async () => {
      try {
        const leaveRes = await request(BASEURL, leaveDetails, {
          empoloyeeid: "VXNlck5vZGU6" + "" + encodedId,
        });
        setLeaveData(leaveRes?.leaveRequestsByMe);

        setLoading(false);
      } catch (err) {
        setError("Error fetching attendance data.");
        setLoading(false);
        console.error("Error fetching check-in data:", err);
      }
    };

    if (userId) {
      fetchUserAttendance();
      fetchUserAttendance3();
    }
  }, [userId]);

  const getLatestAttendanceData = (data) => {
    const latestData = {};
    data.forEach((item) => {
      const date = moment(item.checkIn || item.checkOut).format("YYYY-MM-DD");
      if (!latestData[date]) {
        latestData[date] = { ...item };
      } else {
        // Keep earliest checkIn
        if (item.checkIn && (!latestData[date].checkIn || moment(item.checkIn).isBefore(latestData[date].checkIn))) {
          latestData[date].checkIn = item.checkIn;
        }
        // Keep latest checkOut
        if (item.checkOut && (!latestData[date].checkOut || moment(item.checkOut).isAfter(latestData[date].checkOut))) {
          latestData[date].checkOut = item.checkOut;
        }
        // Keep latest totalWorkingHours and overtime
        if (moment(item.lastUpdate).isAfter(latestData[date].lastUpdate)) {
          latestData[date].totalWorkingHours = item.totalWorkingHours;
          latestData[date].overtime = item.overtime;
          latestData[date].lastUpdate = item.lastUpdate;
        }
      }
    });
    return Object.values(latestData);
  };

  const latestAttendanceData = getLatestAttendanceData(events);

  const events1 = latestAttendanceData.map((item) => {
    const checkIn = item.checkIn
      ? moment(item.checkIn).format("hh:mm A")
      : "N/A";
    const checkOut = item.checkOut
      ? moment(item.checkOut).format("hh:mm A")
      : "In Progress";
    const totalWorkingHours = item.totalWorkingHours || "N/A";
    const overTime = item?.overtime || "0:00";
    const isInProgress = item.checkIn && !item.checkOut;

    return {
      title: isInProgress
        ? `In: ${checkIn}\nStatus: In Progress`
        : `In: ${checkIn}\nOut: ${checkOut}\nTotal: ${totalWorkingHours} hrs\nOT: ${overTime} hrs`,
      start: item.checkIn
        ? moment(item.checkIn).toDate()
        : item.checkOut
        ? moment(item.checkOut).toDate()
        : null,
      end: item.checkOut
        ? moment(item.checkOut).toDate()
        : item.checkIn
        ? moment(item.checkIn).toDate()
        : null,
      totalWorkingHours: item.totalWorkingHours,
      isInProgress,
      type: "attendance",
    };
  });

  const eventStyleGetter = (event) => {
    let backgroundColor;

    if (event.type === "attendance") {
      backgroundColor = "#f38875";
      if (event.start && event.end && event.totalWorkingHours !== "N/A") {
        const hours = parseFloat(event.totalWorkingHours);
        if (hours >= 8) {
          // backgroundColor = "rgba(0, 128, 0, 0.8)";
          backgroundColor = "#88fd8b ";
        } else if (hours >= 0) {
          backgroundColor = "#22BCF2";
        }
      }
    } else if (event.type === "leave") {
      if (event?.title == "Sick Leave") {
        backgroundColor = "#4FC3F7";
      } else if (event?.title == "Cacusal Leave") {
        backgroundColor = "#FFB74D";
      } else if (event?.title == "Earned Leave") {
        backgroundColor = "#81C784";
      } else if (event?.title == "Loss Of Pay") {
        backgroundColor = "#E57373";
      } else if (event?.title == "Privilege Leave") {
        backgroundColor = "#9575CD";
      } else if (event?.title == "Annual Leave") {
        backgroundColor = "#FF8A65";
      } else if (event?.title == "Maternity Leave") {
        backgroundColor = "#FF4E88";
      } else if (event?.title == "Paternity Leave") {
        backgroundColor = "#B1C29E";
      } else if (event?.title == "Restricted Holiday") {
        backgroundColor = "#FCF596";
      }else {
        backgroundColor = "#4FC3F7";
      }
    }

    const style = {
      backgroundColor,
      borderRadius: "10px",
      opacity: 1,
      color: "white",
      border: "1px solid #fff",
      boxShadow: "0px 3px 5px rgba(0,0,0,0.2)",
      padding: "5px",
      display: "block",
    };

    return { style };
  };
  const formatText = (text) => {
    if (typeof text !== "string") return "";
    return text
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const leaveEvents = leaveData
    .filter((leave) => leave.status === "approved")
    .map((leave) => ({
      title: formatText(leave.leaveType?.leaveType),
      start: moment(leave.leaveFrom).toDate(),
      end: moment(leave.leaveTill).add(1, "day").toDate(),
      type: "leave",
    }));
  const CustomEvent = ({ event }) => {
    const lines = event.title.split("\n");

    return (
      <Box
        sx={{
          fontSize: "1rem",

          // lineHeight: "1.5rem",
          // color: theme.palette.grey[900],
          color: "#fff",
          // color:"black",
          // backgroundColor: theme.palette.grey[100],
          // backgroundColor: "lightgreen",
          padding: "2px",
          borderRadius: "5px",
          border: `0px solid ${
            lines == "Sick Leave" ? "white" : theme.palette.primary.main
          }`,
          whiteSpace: "pre-wrap",
        }}
      >
        {lines.map((line, index) => {
          return (
            <p key={index} variant="body2" style={{ fontSize: "12px" }}>
              {line}
            </p>
          );
        })}
      </Box>
    );
  };

  return (
    <DashboardLayout>
      <Box sx={{ padding: "20px", position: "relative" }}>
        {loading ? (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" variant="h6" align="center">
            {error}
          </Typography>
        ) : (
          <Box
            sx={{
              backgroundColor: theme.palette.background.paper,
              borderRadius: "16px",
              padding: "20px",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Calendar
              localizer={localizer}
              events={[...events1, ...leaveEvents]}
              startAccessor="start"
              endAccessor="end"
              style={{
                height: 700,
                width: "100%",
                borderRadius: "16px",
                marginBottom: "44px",
              }}
              eventPropGetter={eventStyleGetter}
              components={{
                event: CustomEvent,
              }}
            />
          </Box>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default Callender;
